<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row no-gutters>
            <v-col cols="3">Filtri</v-col>
            <v-col cols="8" class="text--secondary">
              <span  v-if="open" key="0">Imposta i filtri di visualizzazione</span>
              <span v-else key="1">
                {{ startFormatted }} -  {{ endFormatted }} <v-chip class="mr-1" v-for="x in unionFiltri" :key="x">{{ x }}</v-chip> {{ filtro.riferimento }}
                <v-chip class="mr-1" v-if="filtro.soloNonTrasferiti">Solo non trasferiti</v-chip>
                <v-chip class="mr-1" v-if="filtro.soloTrasferiti">Solo trasferiti</v-chip>
                <v-chip class="mr-1" v-if="filtro.soloInErrore">Solo in errore</v-chip>
              </span>
            </v-col>
            <v-col cols="1" v-if="open"><v-btn @click.stop="onFiltra">Ricerca</v-btn></v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row justify="start">
          <v-col xs="12" sm="6" md="3" lg="2">
            <v-menu
              v-model="menuStart"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="computedStartFormatted"
                  label="Dalla data"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  @click:clear="filtro.start = null"
                ></v-text-field>
              </template>
              <v-date-picker v-model="filtro.start" no-title scrollable @input="menuStart = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col xs="12" sm="6" md="3" lg="2">
            <v-menu
              v-model="menuEnd"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="computedEndFormatted"
                  label="Alla data"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  @click:clear="filtro.end = null"
                ></v-text-field>
              </template>
              <v-date-picker v-model="filtro.end" no-title scrollable @input="menuEnd = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col xs="12" sm="6" md="4" lg="3">
            <v-combobox
              v-model="filtro.elencoScontrini"
              :items="baseElenco"
              :search-input.sync="search"
              hide-selected
              label="Aggiungi i numeri degli scontrini da ricercare"
              multiple
              persistent-hint
              small-chips
              class="pt-0"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      "<strong>{{ search }}</strong>" Premi <kbd>enter</kbd> per aggiungere
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>
          </v-col>  
        </v-row>
        <v-row>
          <v-col xs="12" sm="6" md="3" lg="2">
            <v-switch v-model="filtro.soloNonTrasferiti" class="mt-1" inset label="Solo non trasferiti" @change="onSoloNonTrasferiti"></v-switch>
          </v-col>
          <v-col xs="12" sm="6" md="3" lg="2">
            <v-switch v-model="filtro.soloTrasferiti" class="mt-1" inset label="Solo trasferiti" @change="onSoloTrasferiti"></v-switch>
          </v-col>
          <v-col xs="12" sm="6" md="3" lg="2">
            <v-switch v-model="filtro.soloInErrore" class="mt-1" inset label="Solo in errore" @change="onSoloInErrore"></v-switch>
          </v-col>                    
        </v-row>      
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
/*   import _ from 'lodash'
  import configurazioni from '@/services/configurazioniService.js' */

  export default {
    data: (vm) => ({
      startFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      endFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      filtro: {
        start: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        end: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        soloNonTrasferiti: true,
        soloTrasferiti: false,
        soloInErrore: false,
        elencoScontrini: []
      },
      menuStart: false,
      menuEnd: false,
      modal: false,
      loading: false,
      baseElenco: [],
      search: null
    }),
    created() {
    },
    async mounted() {
      this.$emit('ricerca', this.filtro)
    },
    computed: {
      unionFiltri() {
        return []
      },
      computedStartFormatted () {
        return this.formatDate(this.filtro.start)
      },
      computedEndFormatted () {
        return this.formatDate(this.filtro.end)
      }
    },
    watch: {
      'filtro.start' (val) {
        this.startFormatted = this.formatDate(this.filtro.start)
      },
      'filtro.end' (val) {
        this.endFormatted = this.formatDate(this.filtro.end)
      }    
    },
    methods: {
      onSoloTrasferiti() {
        this.filtro.soloNonTrasferiti = false
        this.filtro.soloInErrore = false
        this.onFiltra()
      },
      onSoloNonTrasferiti() {
        this.filtro.soloTrasferiti = false
        this.filtro.soloInErrore = false
        this.onFiltra()
      },
      onSoloInErrore() {
        this.filtro.soloNonTrasferiti = false
        this.filtro.soloTrasferiti = false
        this.onFiltra()
      },      
      onFiltra() {
        this.$emit('ricerca', this.filtro)
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      }
    }
  }
</script>
